import type { RestorationPlan } from "../../types/dental";

interface CrownToolboxProps {
  plan: RestorationPlan;
  onUpdatePlan: (planId: string, updates: Partial<RestorationPlan>) => void;
  onGenerateCrown: () => void | Promise<void>;
  isGeneratingCrown?: boolean;
}

export function CrownToolbox({
  plan,
  onUpdatePlan,
  onGenerateCrown,
  isGeneratingCrown = false,
}: CrownToolboxProps) {
  return (
    <section className="procedure-toolbox-card card">
      <h3>Crown Toolbox</h3>

      <div className="field-stack">
        <div className="field-row">
          <label>Crown Catalog Item</label>
          <input
            type="text"
            value={plan.selectedCatalogItem || ""}
            onChange={(e) =>
              onUpdatePlan(plan.planId, {
                selectedCatalogItem: e.target.value,
              })
            }
          />
        </div>

        <div className="field-row">
          <label>Material</label>
          <select
            value={plan.material || ""}
            onChange={(e) =>
              onUpdatePlan(plan.planId, { material: e.target.value })
            }
          >
            <option value="">Select material</option>
            <option value="Zirconia">Zirconia</option>
            <option value="Lithium Disilicate">Lithium Disilicate</option>
            <option value="PMMA">PMMA</option>
          </select>
        </div>

        <div className="field-row">
          <label>Shade</label>
          <input
            type="text"
            value={plan.shade || ""}
            onChange={(e) =>
              onUpdatePlan(plan.planId, { shade: e.target.value })
            }
          />
        </div>

        <div className="field-row">
          <label>Spacing / Clearance Notes</label>
          <textarea
            value={plan.spacingNotes || ""}
            onChange={(e) =>
              onUpdatePlan(plan.planId, { spacingNotes: e.target.value })
            }
          />
        </div>

        <div className="field-row">
          <label>Design Notes</label>
          <textarea
            value={plan.designNotes || ""}
            onChange={(e) =>
              onUpdatePlan(plan.planId, { designNotes: e.target.value })
            }
          />
        </div>

        <div className="field-row">
          <button
            type="button"
            className="primary-button"
            onClick={() => {
              void onGenerateCrown();
            }}
            disabled={isGeneratingCrown}
          >
            {isGeneratingCrown ? "Generating..." : "Generate Crown"}
          </button>
        </div>
      </div>
    </section>
  );
}